import { useState } from 'react';
import { Button, Dropdown, Flex, Tooltip } from 'antd';
import { ExitIcon, MenuIcon, StarIcon, FilledStar } from '../../assets/icons';
import MuteIcon from '../../assets/icons/Mute';
import { useNavigate, useParams } from 'react-router';
import ApiService from '../../API/apiService';
import { API_ENDPOINTS } from '../../API/endpoints';
import { handleApiError, localStorageUtil } from '../../utils/CommonFunctions';
import ConfirmationModal from './modals/ConfirmationModal';
import { useBridgeStore } from '../../store/apis/useBridgeStore';
import { useEffect } from 'react';
import { useUserSelfStore } from '../../store/apis/useUserStore';

const ChannelListItem = ({ channel, getChannelListApi, getFavListApi, isFavoriteList = false, hideMoreOptions = false }) => {
  const navigate = useNavigate();
  const { name } = useParams();
  const [dropdownOpen, setChannelDropdownOpen] = useState(false);
  // const userData = JSON.parse(localStorage.getItem('userData') || '{}');
  const userData = useUserSelfStore((state) => state.userSelfData)
  const [isConfirmationPopup, setIsConfirmationPopup] = useState(false);
  const [isFavorite, setIsFavorite] = useState(channel?.isFavorite || false);
  const [loading, setLoading] = useState(false);
  const [isMuted, setIsMuted] = useState(userData?.muteChannels?.includes(channel?._id));
  const triggerSidebarRefresh = useBridgeStore((state) => state.triggerSidebarRefresh);
  const triggerHeaderRefresh = useBridgeStore((state) => state.triggerHeaderRefresh);

  

  const checkMuteStatus = () => {
    const userData = localStorageUtil.getItem("userData");
    const isMuted =
      userData?.muteChannels?.includes(channel?._id) || false;      
    setIsMuted(isMuted);
  };

  useEffect(() => {
    checkMuteStatus();
  }, [channel])

  const handleChannelMuteStatusChange = async (id, isMuted) => {
    isMuted ? handleChannelUnMuteUserApi(id) : handleChannelMuteUserApi(id);
  };

  const handleFavoriteToggle = async (id) => {
    setLoading(true);
    try {
      const endpoint = isFavorite
        ? `${API_ENDPOINTS.removeFavoriteChannel}`
        : `${API_ENDPOINTS.addFavoriteChannel}`;

      const response = await ApiService.post(endpoint, { favoriteChannelId: id, userId: userData?._id });

      if (response?.data && response?.status === 1) {
        await getChannelListApi();
        await getFavListApi();
        setIsFavorite(!isFavorite);
        triggerHeaderRefresh(Date.now(), 'favorite')
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleChannelMuteUserApi = async (id) => {
    try {
      const response = await ApiService.post(
        API_ENDPOINTS.muteManage,
        { channelId: id }
      );

      if (response?.status === 1) {
        // userData.muteChannels = response.data.muteChannels;
        // localStorage.setItem('userData', JSON.stringify(userData));
        const existingUserData = JSON.parse(localStorage.getItem('userData')) || {};
  const updatedUserData = {
    ...existingUserData,
    muteChannels: response.data.muteChannels
  };
  localStorage.setItem('userData', JSON.stringify(updatedUserData));
        setIsMuted(true);
        setChannelDropdownOpen(false);
        triggerHeaderRefresh(Date.now());
        triggerSidebarRefresh(Date.now(), 'channel');
      }
    } catch (error) {
      handleApiError(error);
    }
  };

  const handleChannelUnMuteUserApi = async (id) => {
    try {
      const response = await ApiService.post(
        API_ENDPOINTS.unmuteChannel,
        { channelId: id }
      );

      if (response?.status === 1) {
        // userData.muteChannels = response.data.muteChannels;
        // localStorage.setItem('userData', JSON.stringify(userData));
        // userData.muteChannels = response.data.muteChannels;
        // localStorage.setItem('userData', JSON.stringify(userData));
        const existingUserData = JSON.parse(localStorage.getItem('userData')) || {};
  const updatedUserData = {
    ...existingUserData,
    muteChannels: response.data.muteChannels
  };
  localStorage.setItem('userData', JSON.stringify(updatedUserData));
        setIsMuted(false);
        setChannelDropdownOpen(false);
        triggerHeaderRefresh(Date.now());
        triggerSidebarRefresh(Date.now(), 'channel');
      }
    } catch (error) {
      handleApiError(error);
    }
  };

  const toggleReadStatus = async (id, isUnread) => {
    setLoading(true);
    try {
      const endpoint = isUnread
        ? `${API_ENDPOINTS.messageSeenChannel}/${id}`
        : `${API_ENDPOINTS.unreadmessageSeenChannel}/${id}`;
      const method = isUnread ? 'get' : 'put';

      const response = await ApiService[method](endpoint);

      if (response?.data) {
        userData.lastActiveChat = { id, type: 'channel' };
        localStorage.setItem("userData", JSON.stringify(userData));
        if (isFavoriteList) {
          await getFavListApi();
        } else {
          await getChannelListApi();
        }
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  

  const menuItems = [
    {
      key: 'sidebarChannelddItem-1',
      label: channel?.unreadCount > 0 ? 'Mark as read' : 'Mark as unread',
      icon: <MenuIcon />,
      onClick: () => toggleReadStatus(channel._id, channel?.unreadCount > 0|| channel?.unseenMessagesCount > 0),
    },
    {
      key: 'sidebarChannelddItem-2',
      label: isFavorite ? 'Unfavorite' : 'Favorite',
      icon: isFavorite ? <FilledStar /> : <StarIcon />,
      onClick: () => handleFavoriteToggle(channel._id),
    },
    {
      key: 'sidebarChannelddItem-7',
      label: userData?.muteChannels?.includes(channel._id) ? 'Unmute Channel' : 'Mute Channel',
      icon: <MuteIcon />,
      onClick: () => handleChannelMuteStatusChange(channel?._id,isMuted),
    },
    
    !channel.isDefault && {
      key: 'sidebarChannelddItem-8',
      label: 'Leave Channel',
      className: 'text-danger',
      icon: <ExitIcon />,
      onClick: () => {
        setIsConfirmationPopup(true);
        setChannelDropdownOpen(false);
      },
    },
  ].filter(Boolean);
  const hasUnread = channel?.unreadCount > 0 || channel?.unseenMessagesCount > 0;

  function formatChannelName(channelName) {
    return channelName.length < 20
      ? channelName
      : `${channelName.slice(0, 17)}...`;
  }

  return (
    <>
      <Flex
        justify="space-between"
        align="center"
        gap="middle"
        className={isMuted ? 'sidebar-mute' : ''}
      >
        <Tooltip
          arrow={{ pointAtCenter: true }}
          style={hasUnread ? { fontWeight: 'bold', color: '#FFFFFF' } : {}}
          className={hasUnread ? 'name highlight' : 'name'}
          title={channel?.channelName || ''}
        >
          {formatChannelName(channel?.channelName) || 'Channels'}
        </Tooltip>

        {!hideMoreOptions && (
          <>
            <span className="unread-msg-count">
              {(channel?.unreadCount || channel?.unseenMessagesCount) || ''}
            </span>

            <div
              className="mute-icon-wrapper"
              onClick={(e) => e.stopPropagation()}
            >
              {isMuted && <MuteIcon />}
              <Dropdown
                open={dropdownOpen}
                onOpenChange={(open) => setChannelDropdownOpen(open)}
                menu={{ items: menuItems }}
                className="ec-dropdown sidebar-channel-dropdown"
                trigger={['click']}
                dropdownRender={(menu) => (
                  <div className="ec-dropdown__menu sidebar-channel-dropdown__menu">
                    {menu}
                  </div>
                )}
              >
                <Button
                  type="text"
                  className="options-menu-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    setChannelDropdownOpen(!dropdownOpen);
                  }}
                >
                  <i className="fa-solid fa-ellipsis-vertical"></i>
                </Button>
              </Dropdown>
            </div>
          </>
        )}
      </Flex>
      {!hideMoreOptions && (
        <ConfirmationModal
          isOpen={isConfirmationPopup}
          onClose={() => setIsConfirmationPopup(false)}
          channelId={channel?._id}
          onSuccess={() => {
            getChannelListApi();
            getFavListApi();
          }}
        />
      )}
    </>
  );
};

export default ChannelListItem;